import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ApiService from "@/service/api.service"; 
ApiService.init();
// import axios from 'axios'
// import VueAxios from 'vue-axios'
// Vue.use(VueAxios, axios)


Vue.config.productionTip = false

import 'element-ui/lib/theme-chalk/index.css'
import element from "./element-ui/element"
Vue.use(element);
import 'element-ui/lib/theme-chalk/display.css';

import './assets/font/font.css' 
import 'animate.css/animate.min.css' //引入 npm install animate.css@3.5.1 --save

import Meta from "vue-meta";
Vue.use(Meta);



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
